import AdminView from './Admin.view';
export * from './Admin.view';

export const Admin = (props) => AdminView(props);

export default Admin;

